/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as errors from "../../../../errors/index.js";
import * as core from "../../../../core/index.js";

export class NotFoundError extends errors.LangfuseAPIError {
  constructor(body?: unknown, rawResponse?: core.RawResponse) {
    super({
      message: "NotFoundError",
      statusCode: 404,
      body: body,
      rawResponse: rawResponse,
    });
    Object.setPrototypeOf(this, NotFoundError.prototype);
  }
}
